module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datepickerrange"
  }, [_c('div', {
    staticClass: "dateselector dateselector-start"
  }, [_c('dateselector', {
    attrs: {
      "date": _vm.start,
      "minDate": _vm.minDate,
      "maxDate": _vm.maxDate
    },
    on: {
      "changed": _vm.setStartDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dateselector dateselector-line"
  }, [_vm._v("\n    -\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "dateselector dateselector-end"
  }, [_c('dateselector', {
    attrs: {
      "date": _vm.end,
      "minDate": _vm.minDate,
      "maxDate": _vm.maxEndDate
    },
    on: {
      "changed": _vm.setEndDate
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26141f76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datepicker/DatePickerRange.vue
// module id = 1814
// module chunks = 1